/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 16:43
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').
    factory('Booking_Resource',["$resource","$location", function ($resource,$location)
    {
        var resourceBooking;
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        resourceBooking = $resource(baseUrl + 'rest/bookings/:date/:id', {}, {
            query: { method: 'GET', isArray: true },
            get: { method: 'GET' },
            getHistory: { method: 'GET', url: baseUrl + 'rest/bookings/getHistory/:id' },
            getAvailableTimes: { method: 'POST', url: baseUrl + 'rest/bookings/availableTimes'},
            saveTransaction :  { method: 'POST', url: baseUrl + 'rest/bookings/saveTransaction'},
            onlineSave :  { method: 'POST', url: baseUrl + 'rest/bookings/onlineSave'}
        });
        return resourceBooking;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('Booking',["CustomerData","BookingService","Booking_Resource","Period","BookingData","DayData","SaleProduct","Payment","Sale","SaleData","VatData","TaxMode",
        function (CustomerData,BookingService,Booking_Resource,Period,BookingData,DayData,SaleProduct,Payment,Sale,SaleData,VatData,TaxMode)
        {
        //Booking inherit of Booking_Resource

        var  Booking = function (bookingRes,day,mustloadBookingElements,isPreviousVersion, isApplicationLoading)
        {
            //bookingRes : json resource
            //day : Day of booking (real oject)
            //mustloadBookingServices : boolean
            //isPreviousVersion : boolean (if the instance is a previous version -> do not add to active objects)
            this.id = null;
            this.isDeleted = false;
            this.timeCreated = null;
            this.day = null;
            this.status = "created";
            this.creator = null;
            this.comment = null;
            this.techNote = null;
            this.period = null;
            this.price = 0;
            this.discountPercent = 0;
            this.payments = [];
            this._customerId=null;  //tmp for loading only
            this._customer=null;  //tmp for loading only
            this.customer = null;
            this.isCreatedByCustomer = false;//Default value
            this.bookingServices=[];
            this.selectedHumanResource = null;
            this.sale=null;
            this._saleId= null;
            this.version = null;
            if (bookingRes!==undefined && bookingRes!=null)
            {
                this.loadObjectProperties(bookingRes, null, isApplicationLoading);
                if (mustloadBookingElements)
                {
                    this.loadObjectBookingServices(bookingRes,isPreviousVersion, isApplicationLoading);
                }
            }
            if (day!==undefined && day!=null)
               this.day = day;

            if (isPreviousVersion==undefined || !isPreviousVersion)//A previous version is not added to DATA
                BookingData.add(this, isApplicationLoading);

            this.saveTransactionOrigin = null;
        };
        Booking.prototype.loadObject = function(object, isApplicationLoading)
        {
            this.loadObjectProperties(object);
            this.loadObjectBookingServices(object, false, isApplicationLoading);
        };
        Booking.prototype.loadObjectProperties = function(object)
        {
            if (!this.id)
                this.id = object.id;
            if (object.timeCreated)
                this.timeCreated = new Date(object.timeCreated);
            if (object.timeModified)
                this.timeModified = new Date(object.timeModified);
            this.isDeleted = object.isDeleted;
            this.status = object.status;
            if(object.creator != null)
                this.creator = object.creator;
            this.comment = object.comment;
            this.techNote = object.techNote;
            this.price = object.price;
            this.discountPercent = object.discountPercent;
            this.payments = [];
            if (object.payments)
                for (var i=0;i<object.payments.length;i++)
                    this.payments.push(new Payment(object.payments[i]));
            this._saleId = object.saleId;
            this._customerId=object.customerId;
            this._customer =  object.customer;
            this.isCreatedByCustomer = object.isCreatedByCustomer;
            this.setPeriod(object.period);
            if (object.version)
                this.version = object.version;
        };
        Booking.prototype.loadObjectBookingServices = function(object,isPreviousVersion, isApplicationLoading)
        {
            if (object.bookingServices)
            {
                this.bookingServices=[];//set to 0 and reload
                for (var i=0;i< object.bookingServices.length;i++)
                    this.addBookingService(new BookingService(object.bookingServices[i],isPreviousVersion, isApplicationLoading));
            }
        };
        Booking.prototype.loadRef = function(isPreviousVersion, isApplicationLoading)
        {
            if (this._customerId && (!this.customer || !isApplicationLoading))
            {
                this.customer = CustomerData.getById(this._customerId, isApplicationLoading);
                if (!this.isDeleted && this.customer && (isPreviousVersion===undefined || !isPreviousVersion)) {
                    this.customer.addBooking(this);
                }
            }
            if (this._saleId && (!this.sale || !isApplicationLoading))
            {
                this.sale =  SaleData.getById(this._saleId, isApplicationLoading);
                if (this.sale && !this.sale.booking)//patch for old errors
                    this.sale.booking = this;
            }
            for (var i=0;i< this.bookingServices.length;i++)
                this.bookingServices[i].loadRef();
        };
        Booking.prototype.removeRef = function()
        {
            if (this.customer) {
                this.customer.removeBooking(this);
            }
        };
        Booking.prototype.getObjectResource = function()
        {
            var bookingRes = new Booking_Resource();
            bookingRes.id = this.id;
            bookingRes.isDeleted = this.isDeleted;
            bookingRes.status = this.status;
            bookingRes.creator = this.creator;
            bookingRes.comment = this.comment;
            bookingRes.techNote = this.techNote;
            bookingRes.price = this.price;
            bookingRes.version = this.version;
            bookingRes.discountPercent = this.discountPercent;
            bookingRes.payments = [];
            if (this.payments)
                for (var i=0;i<this.payments.length;i++)
                    bookingRes.payments.push(this.payments[i].getObjectResource());
            if (this.sale)
                bookingRes.saleId = this.sale.id;
            if (this.day)
                bookingRes.dayId = this.day.id;

            if (this.selectedHumanResource)
                bookingRes.selectedHumanResourceId = this.selectedHumanResource.id;

            if (this.period)
            {
                bookingRes.period = this.period.getObjectResource();
            }
            bookingRes.isCreatedByCustomer = this.isCreatedByCustomer;
            if (this.customer)//always save it
                    bookingRes.customer = this.customer.getObjectResource();

            bookingRes.bookingServices=[];
            for (var i=0;i< this.bookingServices.length;i++){
                bookingRes.bookingServices.push(this.bookingServices[i].getObjectResource());
            }
            bookingRes.saveTransactionOrigin = this.saveTransactionOrigin;
            return bookingRes;
        };
        Booking.prototype.setPeriod = function(period)
        {
            if (period)
                this.period = new Period(period)
        }
        Booking.prototype.getId = function()
        {
            return this.id;
        };
        Booking.prototype.setId = function(id)
        {
            if (this.id==null)
                this.id = id;
        };
        Booking.prototype.getPrice = function()
        {
            return this.price;
        };
        Booking.prototype.setPrice = function(price)
        {
            this.price = price;
        };
        Booking.prototype.getIndexOfBsFromIdInBooking = function(idInBooking){
            if(idInBooking){
                for (var i = 0; i < this.bookingServices.length; i++) {
                    if(this.bookingServices[i].idInBooking && this.bookingServices[i].idInBooking == idInBooking)
                        return i;
                }
            }
            return null;
        }
        Booking.prototype.getCustomer = function()
        {
            if (this.customer!=null)
                return this.customer;
            return CustomerData.getById(this.customerId);
        };
        Booking.prototype.getBookingServiceById = function(id)
        {
            var bs = null;
            for (var i=0; i< this.bookingServices.length && !bs;i++)
                if (this.bookingServices[i].id==id)
                    bs = this.bookingServices[i];
                else
                    if (this.bookingServices[i].isPackage)
                        bs = this.bookingServices[i].getSubBookingServiceById(id);
            return bs;
        };
        Booking.prototype.addBookingService = function(bookingService)
        {
            var index =  this.bookingServices.indexOf(bookingService);
            if (index==-1)
            {
                this.bookingServices.push(bookingService);
                bookingService.booking = this;
            }
        };
        Booking.prototype.removeBookingService = function(bookingService)
        {
            if (bookingService!=null)
            {
                var index =  this.bookingServices.indexOf(bookingService);
                if (index!=-1)
                    this.bookingServices.splice(index,1);
                bookingService.booking = null;
            }

        };

        Booking.prototype.removeFromDay = function()
        {
            //remove from day and services from dayhr
            if (this.day)
                this.day.removeBooking(this);
            for (var i=0;i< this.bookingServices.length;i++){
                this.bookingServices[i].removeFromDayHr();
            }


        };
        Booking.prototype.containsGiftOnBs= function(giftItem)
        {
            var containsGift = false;
            if (giftItem)
                for (var i=0;i<this.bookingServices.length;i++)
                    if (this.bookingServices[i].giftItem && this.bookingServices[i].giftItem.id==giftItem.id)
                        containsGift = true;
            return containsGift;
        }
        Booking.prototype.hrIsWorking = function(hrId) {
            var hrIsWorking = false;
            for (var i = 0; i < this.bookingServices.length; i++) {
                if(!this.bookingServices[i].isPackage) {
                    if (this.bookingServices[i].dayHr && this.bookingServices[i].dayHr.humanResourceId === hrId) {
                        hrIsWorking = true;
                        break;
                    }
                }
                else{
                    for(var j = 0; j < this.bookingServices[i].subBookingServices.length; j++){
                        if (this.bookingServices[i].subBookingServices[j].dayHr && this.bookingServices[i].subBookingServices[j].dayHr.humanResourceId === hrId) {
                            hrIsWorking = true;
                            break;
                        }
                    }
                }
            }
            return hrIsWorking;
        }
        Booking.prototype.getDiscountPrice = function(taxMode)
        {
            var discountPrice = 0;
            if(this.sale == null) {
                var defaultVat = VatData.getDefaultVat();

                if (taxMode === TaxMode.HT) {
                    discountPrice = this.price / (100 + defaultVat.tax) * 100;
                }
                else {
                    discountPrice = this.price;
                }
            }
            else if (taxMode === TaxMode.HT) {
                discountPrice = this.sale.priceHT;
            }
            else {
                discountPrice = this.sale.price;
            }

            return discountPrice;
        };

        Booking.prototype.checkBookingCreator = function(bookingCreator){
            let isSameCreator = false;
            if(this.creator && this.creator === bookingCreator)
                isSameCreator = true;
            return isSameCreator;
        };

        return Booking;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('BookingSrv',["$rootScope","$log","ServerSrv","Booking_Resource","Booking","HumanResourceSrv","PhysicalResourceSrv","DayData","UserActionData",
    "BookingData","DayHrData","DayHr","Customer","gettextCatalog","MessageSrv",
        function ($rootScope,$log,ServerSrv,Booking_Resource,Booking,HumanResourceSrv,PhysicalResourceSrv,DayData,UserActionData,
                  BookingData,DayHrData,DayHr,Customer, gettextCatalog,MessageSrv)
        {
        var  bookingSrv = {};
        bookingSrv.newLoadRef = function(isApplicationLoading, start, step) {
            return new Promise((resolve) => {
                let bookingStart = start || 0;
                let bookingStep = step || 10000;

                const bookings = isApplicationLoading ? Object.values(BookingData.objBookings) : BookingData.indexBookings;
                const subBookings = bookings.slice(bookingStart, bookingStart + bookingStep);
                subBookings.map((booking) => {
                    booking.loadRef(null, isApplicationLoading);
                });

                if (subBookings.length === step) {
                    resolve(bookingSrv.newLoadRef(isApplicationLoading, bookingStart + bookingStep, bookingStep));
                } else {
                    resolve();
                }
            });
        };

        bookingSrv.loadRef=  function(isApplicationLoading)
        {
            if(isApplicationLoading){
                let bookings = BookingData.objBookings;
                for (let key in bookings)
                    bookings[key].loadRef(null, isApplicationLoading);
            }
            else {
                var bookings = BookingData.indexBookings;
                for (var i=0;i<bookings.length;i++)
                    bookings[i].loadRef(null,isApplicationLoading);
            }
        };
        bookingSrv.updateBookingServicesId =  function(bsRes,bs)
        {

            bs.setId(bsRes.id);
            if (!bs.version || (bsRes.version && bsRes.version > bs.version))
                bs.version = bsRes.version;
            bs.idInBooking = bsRes.idInBooking;
            // if dayHr created by transaction : set dayHrId
            if (bs.dayHr && !bs.dayHr.id && bsRes.dayHrId)
                bs.dayHr.id = bsRes.dayHrId;
            // if dayHr created by transaction : set dayHrId
            if (bs.dayPr && !bs.dayPr.id && bsRes.dayPrId)
                bs.dayPr.id = bsRes.dayPrId;
            for (var k=0;k< bs.secondariesDayHrs.length;k++)
                if (bs.secondariesDayHrs[k] &&  bsRes.secondariesDayHrsId[k])
                    bs.secondariesDayHrs[k].id = bsRes.secondariesDayHrsId[k];
            for (var k=0;k< bs.secondariesDayPrs.length;k++)
                if (bs.secondariesDayPrs[k] &&  bsRes.secondariesDayPrsId[k])
                    bs.secondariesDayPrs[k].id = bsRes.secondariesDayPrsId[k];
        };
        bookingSrv.save =  function(booking,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(bookingSrv.saveSync, booking, successFunction, errorFunction);
        };
        bookingSrv.saveSync =  function(booking,successFunction,errorFunction)
        {
            var bookingRes = booking.getObjectResource();
            bookingRes.$save({}, //no params
                function (bookingRes) {
                    /** @namespace bookingRes.salesId */
                    /** @namespace bookingRes.bookingServicesId */
                    try {
                        booking.setId(bookingRes.id);
                        if (!booking.version || (bookingRes.version && bookingRes.version > booking.version))
                            booking.version = bookingRes.version;

                        if (bookingRes.timeCreated)
                            booking.timeCreated = new Date(bookingRes.timeCreated);

                        for (var j=0;j< bookingRes.bookingServices.length;j++)
                        {
                            bookingSrv.updateBookingServicesId(bookingRes.bookingServices[j],booking.bookingServices[j]);
                            for (var k=0;k< bookingRes.bookingServices[j].subBookingServices.length;k++)
                                bookingSrv.updateBookingServicesId(bookingRes.bookingServices[j].subBookingServices[k],booking.bookingServices[j].subBookingServices[k]);
                        }

                        if (bookingRes.customer && booking.customer)
                        {
                            booking.customer.setId(bookingRes.customer.id);
                            if (!booking.customer.version || (bookingRes.customer.version && bookingRes.customer.version > booking.customer.version))
                                booking.customer.version = bookingRes.customer.version;

                        }
                        //Add user action
                        UserActionData.add(bookingRes.userAction);
                        //CallBack on success
                        if (successFunction !=undefined)
                            successFunction(bookingRes);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        var errorMessage = "Erreur inconnue lors de la sauvegarde."
                        if (data.status && data.data )
                        {
                            if (data.status=="409" )
                            {
                                if (data.data.errorCode == "40900")
                                    errorMessage = "L'heure choisie pour la réservation n'est plus disponible.";
                                if (data.data.errorCode == "40901")
                                    errorMessage = "Impossible de valider la réservation. Veuillez recharger le site internet et essayer à nouveau.";
                            }
                        }
                        var transLateErrorMessage = gettextCatalog.getString(errorMessage);

                        if (errorFunction !=undefined)
                            errorFunction(transLateErrorMessage);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        bookingSrv.onlineSave =  function(booking,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(bookingSrv.onlineSaveSync, booking, successFunction, errorFunction);
        };
        bookingSrv.onlineSaveSync =  function(booking,successFunction,errorFunction)
        {
            var bookingRes = booking.getObjectResource();
            if (booking.sale)
                bookingRes.sale = booking.sale.getObjectResource();
            bookingRes.$onlineSave({}, //no params
                function (bookingRes) {
                    /** @namespace bookingRes.salesId */
                    /** @namespace bookingRes.bookingServicesId */

                    try {
                        booking.setId(bookingRes.id);
                        if (!booking.version || (bookingRes.version && bookingRes.version > booking.version))
                            booking.version = bookingRes.version;

                        if (booking.sale && bookingRes.sale)
                            booking.sale = bookingRes.sale.id;
                        if (bookingRes.timeCreated)
                            booking.timeCreated = new Date(bookingRes.timeCreated);


                        for (var j=0;j< bookingRes.bookingServices.length;j++)
                        {
                            bookingSrv.updateBookingServicesId(bookingRes.bookingServices[j],booking.bookingServices[j]);
                            for (var k=0;k< bookingRes.bookingServices[j].subBookingServices.length;k++)
                                bookingSrv.updateBookingServicesId(bookingRes.bookingServices[j].subBookingServices[k],booking.bookingServices[j].subBookingServices[k]);

                        }

                        if (bookingRes.customer && booking.customer)
                        {
                            booking.customer.setId(bookingRes.customer.id);
                            if (!booking.customer.version || (bookingRes.customer.version && bookingRes.customer.version > booking.customer.version))
                                booking.customer.version = bookingRes.customer.version;

                        }

                        UserActionData.add(bookingRes.userAction);

                        const partnerId = '10000121';
                        const endpoint = 'https://www.google.com/maps/conversion/collect';

                        const match = document.cookie.match(new RegExp('(?:^| )_rwgToken=([^;]+)'));
                        const storedRwgToken = match ? match[1] : undefined;

                        if (storedRwgToken !== undefined) {
                            fetch(endpoint, {
                                method: "POST",
                                body: JSON.stringify({
                                    conversion_partner_id: partnerId,
                                    rwg_token: decodeURIComponent(storedRwgToken),
                                    merchant_changed: "2"
                                })
                            });
                        }

                        //CallBack on success
                        if (successFunction !=undefined)
                            successFunction(bookingRes);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        var errorMessage = "La transaction a échouée. Veuillez recharger le site internet et essayer à nouveau."
                        if (data.status && data.data )
                        {
                            if(data.status=="400") {
                                data.data.errorCode = "40000";
                                errorMessage = data.data.message;
                            }
                            if (data.status=="409" )
                            {

                                switch(data.data.errorCode) {
                                    case "40900":
                                        errorMessage   = "L'heure choisie pour la réservation n'est plus disponible.";
                                        break;
                                    case "40901":
                                        errorMessage   = "Impossible de valider la réservation. Veuillez recharger le site internet et essayer à nouveau.";
                                        break;
                                    case "101101":
                                    case "101102":
                                    case "101103":
                                    case "101104":
                                    case "101111":
                                    case "101112":
                                    case "101113":
                                    case "101115":
                                    case "101116":
                                    case "101119":
                                    case "101199":
                                        errorMessage = "Transaction refusée par la banque. Merci de vérifier vos autorisations de paiement par internet. (" + data.data.errorCode + ").";
                                        break;
                                    case "101105":
                                        errorMessage = "La carte est expirée (" + data.data.errorCode + ").";
                                        break;
                                    case "101106":
                                    case "101410":
                                        errorMessage = "La carte n'est pas utilisable (" + data.data.errorCode + ").";
                                        break;
                                    case "101303":
                                    case "101302":
                                        errorMessage = "La carte n'est pas compatible avec la sécurité 3D Secure (" + data.data.errorCode + ").";
                                        break;
                                    default:
                                        errorMessage = "Transaction refusée par la banque. Merci de vérifier vos autorisations de paiement par internet. (" + data.data.errorCode + ")."
                                }
                            }
                        }
                        if (errorFunction != undefined) {
                            let transLateErrorMessage = gettextCatalog.getString(errorMessage);
                            errorFunction(data.data.errorCode, transLateErrorMessage);
                        }
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        bookingSrv.remove =  function(booking,successFunction,errorFunction)
        {
            //Remove directly from model
            ServerSrv.startSavingProcess(bookingSrv.removeSync, booking, successFunction, errorFunction);
        };
        bookingSrv.removeSync =  function(booking,successFunction,errorFunction)
        {
            var bookingSrv = new Booking_Resource();
            bookingSrv.$remove({id:booking.getId()}, //params : id
                function (data) {
                    try {
                        UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        bookingSrv.getHistory =  function(bookingId,successFunction,errorFunction)
        {
            Booking_Resource.getHistory(
                {id:bookingId},
                function (bookingsRes) {   //success
                    var bookings = [];
                    var booking;
                    if (bookingsRes && bookingsRes.bookings)
                    {
                        for (var i=0;i<bookingsRes.bookings.length;i++)
                        {
                            booking = new Booking(bookingsRes.bookings[i],null,true,true);
                            booking.dayId = bookingsRes.bookings[i].dayId;
                            bookings.push(booking);
                        }
                    }
                    //CallBack on success
                    if (successFunction !=undefined)
                        successFunction(bookings);
                },
                function (data) {
                    if (errorFunction !=undefined)
                        errorFunction(data);
                });
        };
        bookingSrv.executeTransaction =  function(transaction,successFunction,errorFunction) {
            ServerSrv.startSavingProcess(bookingSrv.executeTransactionAsync, transaction, successFunction, errorFunction);
        };
        bookingSrv.executeTransactionAsync =  function(transaction,successFunction,errorFunction)
        {
            if (transaction && transaction.objects && transaction.objects.length>0 && !$rootScope.readOnly)
            {
                var transactionResource = new Booking_Resource();
                transactionResource.bookings = [];
                for (var i=0;i<transaction.objects.length;i++){
                    transactionResource.bookings.push(transaction.objects[i].getObjectResource());
                }
                transactionResource.$saveTransaction({}, //no params
                    function (data) {
                        try {
                            var booking;
                            var bookingRes;
                            if (data.bookings && transaction.objects.length ==data.bookings.length) {
                                for (var i = 0; i < transaction.objects.length; i++) { //Consider order must be the same
                                    var j;
                                    booking = transaction.objects[i];
                                    bookingRes = data.bookings[i];

                                    booking.setId(bookingRes.id);
                                    if (!booking.version || (bookingRes.version && bookingRes.version > booking.version)) {
                                        booking.version = bookingRes.version;
                                    }
                                    if (bookingRes.timeCreated) {
                                        booking.timeCreated = new Date(bookingRes.timeCreated);
                                    }
                                    if (bookingRes.bookingServices && bookingRes.bookingServices.length == booking.bookingServices.length) {
                                        for (j = 0; j < bookingRes.bookingServices.length; j++) {
                                            var indexOfBookingService = booking.getIndexOfBsFromIdInBooking(bookingRes.bookingServices[j].idInBooking);
                                            if (indexOfBookingService == null) {
                                                indexOfBookingService = j;
                                            }
                                            bookingSrv.updateBookingServicesId(bookingRes.bookingServices[j], booking.bookingServices[indexOfBookingService]);
                                            for (var k = 0; k < bookingRes.bookingServices[j].subBookingServices.length; k++) {
                                                bookingSrv.updateBookingServicesId(bookingRes.bookingServices[j].subBookingServices[k], booking.bookingServices[indexOfBookingService].subBookingServices[k]);
                                            }

                                        }
                                    } else {
                                        $log.error("executeTransactionAsync : returned list size incorrect !!");
                                    }

                                    if (bookingRes.customer && booking.customer) {
                                        booking.customer.setId(bookingRes.customer.id);
                                        if (!booking.customer.version || (bookingRes.customer.version && bookingRes.customer.version > booking.customer.version))
                                            booking.customer.version = bookingRes.customer.version;
                                    }
                                }
                            }  else {
                                $log.error("executeTransactionAsync : returned list size incorrect !!");
                            }

                            //Add user action
                            UserActionData.add(data.userAction);
                            //CallBack on success
                            if (successFunction) {
                                successFunction(data);
                            }
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try {
                            if (errorFunction) {
                                errorFunction(data);
                            }
                        } finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null),"Booking.executeTransactionAsync - Error on save and server call queue not empty");
                        }
                    }
                );
            }
            else
                ServerSrv.endSavingProcess(true);
        };


        bookingSrv.getAvailableTimes = function(booking)
        {
            var bookingSrv = booking.getObjectResource();
            bookingSrv.$getAvailableTimes({});
        };

        bookingSrv.removeLocally = function(id, resource) {
            let booking = BookingData.getById(id);
            if (booking) {
                if (booking.version && resource.version && resource.version <= booking.version) {
                    return null;
                }

                if (booking.day) {
                    booking.day.removeBooking(booking);
                } else {
                    console.log("Booking.removeLocally - booking.day is null - booking ID: " + id);
                }
                if (booking.customer) {
                    booking.customer.removeBooking(booking);
                }
            } else {
                console.log("Booking.removeLocally - Model not found given ID - booking ID: " + id);
            }
            return booking;
        };

        bookingSrv.addLocally = function(id, resource) {
            let booking = BookingData.getById(id);
            if (booking && booking.version && resource.version && resource.version <= booking.version) {
                return null;
            }

            let day = DayData.getById(resource.dayId);
            if (booking != null) { //check if resource already exist inside index (current action could be a 'cancel')
                console.log("Booking.addLocally - Model already exists - booking ID: " + id);
                if (booking.customer) {
                    booking.customer.removeBooking(booking);
                }
                booking.loadObjectProperties(resource);
            } else {
                booking = new Booking(resource, day, false);//dont load bookingsService (will be done after)
                booking.id = id;
            }
            booking.loadRef();
            if (day) {
                day.addBooking(booking);
            } else {
                console.log("Booking.addLocally - Day not found - Day ID: " + resource.dayId);
            }

            return booking;
        };

        bookingSrv.updateLocally = function(id, resource) {
            let booking = BookingData.getById(id);
            if(!booking) {
                MessageSrv.send("error", gettextCatalog.getString("Veuillez recharger l'application afin d'actualiser les données"));
                console.log("Booking.updateLocally - Model not found given ID - Booking ID: " + id);
            } else {
                if (booking.version && resource.version && resource.version <= booking.version) {
                    return null;
                }

                let newDay =  DayData.getById(resource.dayId);
                if (newDay) {
                    if (booking.day !== newDay) {
                        booking.day.removeBooking(booking);
                        newDay.addBooking(booking);
                    }
                    if (booking.customer) {
                        booking.customer.removeBooking(booking);
                    }
                    booking.loadObject(resource);
                    booking.loadRef();//Will add to customer
                } else {
                    console.log("Booking.updateLocally - Day not found - Day ID: " + resource.dayId);
                }
            }
            return booking;
        };

        bookingSrv.getPreviousVersionInstance =  function(resource)
        {
            var day = DayData.getById(resource.dayId);
            var booking =  new Booking(resource,day,false,true);
            return booking;
        };

        return bookingSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('BookingData',["$log","ModelDataUtil", function ($log,ModelDataUtil)
    {
        var  bookingData =
        {
            objBookings : {},
            indexBookings : []
        };
        bookingData.getById =  function(bookingId, isApplicationLoading)
        {
            let booking = null;
            if(isApplicationLoading){
                booking = this.objBookings[bookingId];
            }
            else {
                for (let i = 0; i < this.indexBookings.length; i++){
                    //Dont replace this == by a === in this method. We need implicit cast comparison
                    if (this.indexBookings[i].id == bookingId) {
                        booking = this.indexBookings[i];
                        break;
                    }
                }
            }
            return booking;
        };

        bookingData.getIndexOf =  function(booking)
        {
            if (booking)
                return this.indexBookings.indexOf(booking);
            return -1;
        }
        bookingData.getByIndex =  function(index)
        {
            if (index>=0 && index<this.indexBookings.length)
                return this.indexBookings[index];
            else
                return null;
        }
        bookingData.add =  function(booking, isApplicationLoading)
        {
            if(isApplicationLoading){
                if(booking && booking.id)
                    this.objBookings[booking.id] = booking;
            }
            else{
                //to do add always sorted
                this.indexBookings.push(booking);
            }
        };

        bookingData.clear =  function()
        {
            bookingData.indexBookings = [];
            bookingData.objBookings = {};
        };

        bookingData.convertMapToArray = function(keepObject, isNewLoading) {
            if (isNewLoading) {
                this.indexBookings = ModelDataUtil.convertObjectToArray(this.objBookings, this.indexBookings);
                if (!keepObject) {
                    this.objBookings = {};
                }
            } else {
                this.indexBookings = ModelDataUtil.convertMapToArray(this.objBookings, this.indexBookings);
                this.objBookings = null;
            }
        };

        return bookingData;
    }
    ]);



// WEBPACK FOOTER //
// ./js/services/models/Booking.js